import { render, staticRenderFns } from "./ledgerFieldConfiguration.vue?vue&type=template&id=07367c88&scoped=true&"
import script from "./ledgerFieldConfiguration.vue?vue&type=script&lang=js&"
export * from "./ledgerFieldConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ledgerFieldConfiguration.vue?vue&type=style&index=0&id=07367c88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07367c88",
  null
  
)

export default component.exports